import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import { RootState } from 'store/reducers';
import { CommunicationsAckPayload, CommunicationsAckResponse, CommunicationsResponse } from './communications.model';
import { COMMUNICATIONS_SOURCE } from './constants';
import { setCommunicationsPayload } from './communicationsSlice';

export const communicationsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTeamCommunications: builder.query<CommunicationsResponse, number>({
      query: teamId => ({
        url: `${API_VERSION.V1}/teams/${teamId}/communications/${COMMUNICATIONS_SOURCE}`,
        method: 'GET'
      }),
      async onQueryStarted(teamId, { dispatch, getState, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data) return;

          const activeTeamId = (getState() as RootState).rootReducer.communications.activeTeamId;
          if (activeTeamId !== teamId) return;

          dispatch(setCommunicationsPayload({ teamId, data }));
        } catch {
          // Keep the last good payload on failure.
        }
      },
      extraOptions: {
        failure: '',
        showToast: false
      }
    }),
    ackTeamCommunications: builder.mutation<
      CommunicationsAckResponse,
      { teamId: number; body: CommunicationsAckPayload }
    >({
      query: ({ teamId, body }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/communications/ack/${COMMUNICATIONS_SOURCE}`,
        method: 'POST',
        body
      }),
      extraOptions: {
        failure: '',
        showToast: false
      }
    })
  })
});

export const { useLazyGetTeamCommunicationsQuery, useAckTeamCommunicationsMutation } = communicationsApi;
